<template>
  <iMenuGroup
    v-if="item.group"
    :title="$t(item.title)">
    <SideBarItem
      v-for="item in item.children"
      :key="item.name"
      :item="item" />
  </iMenuGroup>
  <iSubmenu
    v-else-if="item.children"
    :name="item.name"
    :class="{ 'menu-item-collapsed': collapsed }"
    class="menu-item"
  >
    <template slot="title">
      <iIcon :type="item.icon"/>
      <span v-t="item.title"/>
    </template>
    <SideBarItem
      v-for="item in item.children"
      :key="item.name"
      :item="item" />
  </iSubmenu>
  <iMenuItem
    v-else
    :name="item.name"
    :class="{ disabled: !item.route }"
  >
    <iIcon :type="item.icon"/>
    <span v-t="item.title"/>
  </iMenuItem>
</template>

<script>
export default {
  name: 'SideBarItem',
  props: {
    item: {
      type: Object,
      required: true,
    },
    collapsed: { type: Boolean, default: false },
  },
};
</script>

<style>
.menu-item.menu-item-collapsed .ivu-menu-submenu-title-icon {
  display: none;
}
.ivu-menu-vertical .ivu-menu-submenu .ivu-menu-item {
  padding: 6px 18px;
  padding-left: 16px !important;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.-vertical .ivu-menu-item-group-title {
    height: 30px;
    line-height: 30px;
}

.ivu-menu-item.disabled {
  pointer-events: none;
  cursor: auto;
  background: 0 0!important;
  color: #9999 !important;
}
</style>

<style scoped>
.menu-item .ivu-menu-submenu-title span {
  display: inline-block;
  overflow: hidden;
  width: 104px;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
  transition: width 0.2s ease 0.2s;
}
.menu-item .ivu-menu-submenu-title i {
  transform: translateX(0px);
  transition: font-size 0.2s ease, transform 0.2s ease;
  vertical-align: middle;
  font-size: 16px;
}
.menu-item.menu-item-collapsed .ivu-menu-submenu-title span {
  width: 0px;
  transition: width 0.2s ease;
}
.menu-item.menu-item-collapsed .ivu-menu-submenu-title i {
  transform: translateX(5px);
  transition: font-size 0.2s ease 0.2s, transform 0.2s ease 0.2s;
  vertical-align: middle;
  font-size: 22px;
}
</style>
